import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../widgets/sidebar";
import Header from "../../widgets/header";
import PageLoader from "../../components/pageLoader";
import openIcon from "../../assets/img/icons/openSide.svg";
import { AllContext } from "../../context";
import PaginationNewUI from "../../components/PaginationNewUI";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import _ from "lodash";

const Dashboard = () => {
  const [toggleSideBar, setToggleSidebar] = React.useState(false);
  const [service, setService] = React.useState([]);
  const [totalRevenue, setTotalRevenue] = React.useState(null);
  const [averageRevenue, setAverageRevenue] = React.useState(null);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0); // totalRecords
  const [itemOffset, setItemOffset] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [newClients, setNewClients] = React.useState(null);
  const [revenueByDate, setRevenueByDate] = useState([]);
  const [open, setOpen] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const handleSidebar = () => {
    setToggleSidebar(!toggleSideBar);
  };
  const context = useContext(AllContext);
  const { allApiUrl, apiPostMethod, toastMessage, redirectToLogin } = context;
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.loginReducer.loginUserInfo);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const loginUserAccessToken = useSelector(
    (state) => state.loginReducer.loginUserAccessToken
  );
  const { currency } = useSelector(
    (state) => state.sideMenuReducer.paymentSettingData
  );
  useEffect(() => {
    let loggedIn = localStorage.getItem("userLoggedIn");
    if (loggedIn) {
      setIsLoading(false);
      if (userInfo.group == 1) {
        navigate("/dashboard");
      } else {
        navigate("/home", {
          state: {
            showBackToClientButton: false,
          },
        });
      }
    } else {
      navigate("/login");
    }
    getTenDayData();
  }, []);

  const [dateRange, setDateRange] = useState([new Date(), null]);
  const [startDate, endDate] = dateRange;
  console.log("dateRange",dateRange)

  const onChange = (dates) => {
    console.log("dates",dates)
    const [start, end] = dates;
    setDateRange(dates);
    getDateFilterData(start, end);
    setOpen(false);
  };
  function formatDateMonthName(d) {
    const date = new Date(d);

    if (isNaN(date.getTime())) {
      return d;
    } else {
      const month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      let day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      return day + " " + month[date.getMonth()];
    }
  }

  const endOffset = parseInt(itemOffset) * parseInt(itemsPerPage);
  const currentList = service.slice(
    itemOffset > 1 ? itemOffset * itemsPerPage - (itemsPerPage - 1) - 1 : 0,
    endOffset
  );
  let pageCount = Math.ceil(service.length / itemsPerPage);

  function getDatesInRange(startDate, endDate) {
    const date = new Date(startDate.getTime());
    date.setDate(date.getDate());
    const dates = [];
    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  }

  function getTenDayData() {
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    let data = {
      startDate: new Date(new Date().setDate(new Date().getDate() - 10)),
      endDate: startDate,
    };

    apiPostMethod(allApiUrl.DASHBOARD_DATE_FILTER, data, header)
      .then((res) => {
        setTotalRecordsCount(res.data.data.serviceData.length);

        setService(res.data.data.serviceData);
        const totalRev = _.sumBy(res.data.data.serviceData, (o) => {
          return o.revenueGenerated;
        });
        const average = parseInt(totalRev / res.data.data.invoiceCount);
        setTotalRevenue(totalRev);
        setAverageRevenue(average);
        //revenuByDate
        let startDateFilter = new Date(
          new Date().setDate(new Date().getDate() - (endDate ? endDate : 11))
        );
        let endDateFilter = startDate;
        let startDateSplits = startDateFilter.toLocaleString().split("/");
        let endDateSplits = endDateFilter.toLocaleString().split("/");

        // setIsLoading(false);
        let numOfDays = 0;
        let year = startDateSplits[2];
        year = year.split(",")[0];
        if (startDateSplits[1] == endDateSplits[1]) {
          numOfDays = endDateSplits[0] - startDateSplits[0];
          let finalData = [...Array(numOfDays)].map((_a, index) => {
            let currentDate = index + parseInt(startDateSplits[0]) + 1;
            // let dateExist = _.find(res.data.data.revenueByDate, (row) => { return row.name.split("-")[2] === currentDate; });

            let dateExist = res.data.data.revenueByDate.find((row) => {
              let date = row.name.split("-")[2];
              if (date == currentDate) {
                return true;
              }
              return false;
            });
            if (dateExist) {
              return dateExist;
            } else {
              return {
                name: `${year}-${startDateSplits[1]}-${index + parseInt(startDateSplits[0]) > 9
                  ? currentDate
                  : "0" + currentDate
                  }`,
                revenue: 0,
              };
            }
          });
          finalData.forEach((item, index) => {
            setRevenueByDate(() => {
              finalData[index].name = formatDateMonthName(item.name);
              return [...finalData];
            });
          });
        } else {
          let var1 = new Date(
            startDateFilter.getTime() -
            startDateFilter.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];
          let var2 = new Date(
            endDateFilter.getTime() - endDateFilter.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];
          let currStartDate = startDateFilter.toLocaleString().split(",");
          currStartDate = currStartDate[0];
          currStartDate = currStartDate.replaceAll("/", "-");
          const date = currStartDate;
          const [day, month, year] = date.split("-");
          currStartDate = [year, month, day].join("-");
          let currEndDate = endDateFilter.toLocaleString().split(",");
          currEndDate = currEndDate[0];
          currEndDate = currEndDate.replaceAll("/", "-");
          const dateEnd = currEndDate;
          const [dayEnd, monthEnd, yearEnd] = dateEnd.split("-");
          currEndDate = [yearEnd, monthEnd, dayEnd].join("-");
          let dateRangeDate = getDatesInRange(new Date(var1), new Date(var2));
          function formatDate(date) {
            var d = new Date(date),
              month = "" + (d.getMonth() + 1),
              day = "" + d.getDate(),
              year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
          }
          dateRangeDate = dateRangeDate.flat();
          dateRangeDate = dateRangeDate.map((item) => {
            return formatDate(item);
          });

          let finalData = dateRangeDate.map((_a, index) => {
            let dateExist = res.data.data.revenueByDate.find((row) => {
              let date = row.name.split("-")[2];
              let month = row.name.split("-")[1];
              if (date == _a.split("-")[2] && month == _a.split("-")[1]) {
                return true;
              }
              return false;
            });

            if (dateExist) {
              return dateExist;
            } else {
              return {
                name: _a,
                revenue: 0,
              };
            }
          });
          finalData.forEach((item, index) => {
            setRevenueByDate(() => {
              finalData[index].name = formatDateMonthName(item.name);
              return [...finalData];
            });
          });
        }

        setNewClients(res.data.data.clientCount);
        setInitialLoading(false);
      })
      .catch((err) => {
        redirectToLogin(dispatch, navigate, err);
        setIsLoading(false);
        toastMessage("error", err?.data?.message);
      });
  }

  function getDateFilterData(start, end) {
    let header = {
      Authorization: `Bearer ${loginUserAccessToken}`,
    };
    let data = {};
    if (end && end != startDate) {
      data = {
        startDate: startDate,
        endDate: end,
      };
    } else {
      data = {
        startDate: start ? start : startDate,
      };
    }

    setIsLoading(true);
    apiPostMethod(allApiUrl.DASHBOARD_DATE_FILTER, data, header)
      .then((res) => {
        setTotalRecordsCount(res.data.data.serviceData.length);
        setService(res.data.data.serviceData);
        let totalRev = 0;
        let average;
        for (let item of res.data.data.serviceData) {
          totalRev += item.revenueGenerated;
        }
        average = parseInt(totalRev / res.data.data.invoiceCount);
        setTotalRevenue(totalRev);
        setAverageRevenue(average);
        setIsLoading(false);
        if (startDate && end) {
          let startDateSplits = startDate.toLocaleString().split("/");
          let endDateSplits = end.toLocaleString().split("/");
          let numOfDays = 0;
          let year = startDateSplits[2];
          year = year.split(",")[0];
          if (startDateSplits[1] == endDateSplits[1]) {
            numOfDays = endDateSplits[0] - startDateSplits[0];
            numOfDays += 1;
            let finalData = [...Array(numOfDays)].map((_a, index) => {
              let currentDate = index + parseInt(startDateSplits[0]);
              let dateExist = res.data.data.revenueByDate.find((row) => {
                let date = row.name.split("-")[2];
                if (date == currentDate) {
                  return true;
                }
                return false;
              });
              if (dateExist) {
                return dateExist;
              } else {
                return {
                  name: `${year}-${startDateSplits[1]}-${index + parseInt(startDateSplits[0]) > 9
                    ? currentDate
                    : "0" + currentDate
                    }`,
                  revenue: 0,
                };
              }
            });
            finalData.forEach((item, index) => {
              setRevenueByDate(() => {
                finalData[index].name = formatDateMonthName(item.name);
                return [...finalData];
              });
            });
          } else {
            // else case

            let var1 = new Date(
              startDate.getTime() - startDate.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T")[0];
            let var2 = new Date(end.getTime() - end.getTimezoneOffset() * 60000)
              .toISOString()
              .split("T")[0];

            let currStartDate = startDate.toLocaleString().split(",");
            currStartDate = currStartDate[0];
            currStartDate = currStartDate.replaceAll("/", "-");
            const date = currStartDate;
            const [day, month, year] = date.split("-");
            currStartDate = [year, month, day].join("-");
            let currEndDate = end.toLocaleString().split(",");
            currEndDate = currEndDate[0];
            currEndDate = currEndDate.replaceAll("/", "-");
            const dateEnd = currEndDate;
            const [dayEnd, monthEnd, yearEnd] = dateEnd.split("-");
            currEndDate = [yearEnd, monthEnd, dayEnd].join("-");

            let dateRangeDate = getDatesInRange(new Date(var1), new Date(var2));

            function formatDate(date) {
              var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

              if (month.length < 2) month = "0" + month;
              if (day.length < 2) day = "0" + day;

              return [year, month, day].join("-");
            }
            dateRangeDate = dateRangeDate.flat();
            dateRangeDate = dateRangeDate.map((item) => {
              return formatDate(item);
            });
            let finalData = dateRangeDate.map((_a, index) => {
              let dateExist = res.data.data.revenueByDate.find((row) => {
                let date = row.name.split("-")[2];
                let month = row.name.split("-")[1];
                if (date == _a.split("-")[2] && month == _a.split("-")[1]) {
                  return true;
                }
                return false;
              });

              if (dateExist) {
                return dateExist;
              } else {
                return {
                  name: _a,
                  revenue: 0,
                };
              }
            });
            finalData.forEach((item, index) => {
              setRevenueByDate(() => {
                finalData[index].name = formatDateMonthName(item.name);
                return [...finalData];
              });
            });
          }
        } else {
          let singleDate = new Date(
            start.getTime() - start.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];
          if (res.data.data.revenueByDate.length === 0) {
            res.data.data.revenueByDate[0] = {
              name: singleDate,
              revenue: 0,
            };
          }
          res.data.data.revenueByDate.forEach((item, index) => {
            setRevenueByDate(() => {
              res.data.data.revenueByDate[index].name = formatDateMonthName(
                item.name
              );
              return [...res.data.data.revenueByDate];
            });
          });
        }
        setNewClients(res.data.data.clientCount);
      })
      .catch((err) => {
        redirectToLogin(dispatch, navigate, err);
        setIsLoading(false);
        toastMessage("error", err?.data?.message);
      });
  }

  const formatter = (data) => {
    return `${currency?.symbol ? currency?.symbol : "$"}${data}`;
  };
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0 && payload[0].payload) {
      return (
        <div className="custom-tooltip" style={{ background: "white" }}>
          <p>{payload[0].payload.name}</p>
          <p>
            Revenue <b>${payload[0].payload.revenue.toFixed(2)}</b>
          </p>
        </div>
      );
    }
  };

  return (
    <div>
      <Sidebar
        activePage="dashboard"
        setToggleSidebar={setToggleSidebar}
        toggleSideBar={toggleSideBar}
      />
      <Header isLoading={isLoading} handleSidebar={handleSidebar} />
      <PageLoader isLoading={initialLoading} />
      {!initialLoading && (
        <>
          <div className="commonSlidePl">
            <div className="dashboardSection commonPadding dashboardTop">
              <div className="container-fluid pl-240">
                <div className="row">
                  <div className="col-lg-4 col-md-12">
                    <div className="heading position-relative">
                      <h2 className="fs-3 mb-0">Dashboard</h2>
                      <span
                        className="openArrowIcon"
                        onClick={() => {
                          setToggleSidebar(!toggleSideBar);
                        }}
                      >
                        <img src={openIcon} />
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-12">
                    <div className="dashboardresponsive">


                      <div className="dashboardFilters">
                        <div className="dropdown">
                          <button
                            className="btn btn-secondary dropdown-toggle dashboardDropdown"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ width: "170px" }}
                          >
                            Reports
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                onClick={() => navigate("/revenue")}
                              >
                                Revenue
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                onClick={() => navigate("/service-report")}
                              >
                                Services
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                onClick={() => navigate("/client-report")}
                              >
                                Clients
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                onClick={() => navigate("/sales")}
                              >
                                Sale Performance
                              </a>
                            </li>
                          </ul>

                          {/* <button
                      className="btn btn-secondary dropdown-toggle dashboardDropdown"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Export
                    </button> */}
                          <ul className="dropdown-menu">
                            <li>
                              <a className="dropdown-item" href="#">
                                Accounts
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Orders
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Transactions
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Invoices
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Form Date
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Revenue By Client
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Ticket Rating
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="datepicker-wrapper ms-3">
                        <DatePicker
                          className="form-control"
                          selectsRange
                          text="jhv"
                          maxDate={moment().toDate()}
                          dateFormat="MM/dd/yyyy"
                          startDate={startDate}
                          endDate={endDate}
                          onChange={onChange}
                        />
                      </div>
                      <div className="dashboardFilters">
                        <div className="dropdown">
                          <button
                            className="btn btn-secondary dropdown-toggle "
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="fa-solid fa-calendar"></i>
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => {
                                  getDateFilterData(
                                    new Date(
                                      new Date().setDate(new Date().getDate() - 7)
                                    ),
                                    new Date(
                                      new Date().setDate(new Date().getDate())
                                    )
                                  );
                                }}
                              >
                                Last 7 Days
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) =>
                                  getDateFilterData(
                                    new Date().setDate(new Date().getDate()),
                                    new Date().setDate(new Date().getDate() - 28)
                                  )
                                }
                              >
                                Last 4 Weeks
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) =>
                                  getDateFilterData(
                                    new Date().setDate(new Date().getDate()),
                                    new Date().setDate(new Date().getDate() - 90)
                                  )
                                }
                              >
                                Last 3 Months
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Previous Month
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Month to Date
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Quarter to Date
                              </a>
                            </li>
                            <li>
                              <a className="ndropdown-item" href="#">
                                Year to Date
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                All Time
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboardSection commonPadding pb-1 horizontalPadding">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="row">
                      <div className="col-lg-3 col-md-3">
                        <div className="tile">
                          <div className="row">
                            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-3">
                              <div className="tileImg">
                                {/* <img src={valueIcon} /> */}

                                <span>
                                  <svg
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M46.653 28.1063H43.6281C43.1274 28.1063 42.6955 27.7575 42.5891 27.2677C42.2631 25.7559 41.6725 24.3306 40.8344 23.0297C40.5627 22.6087 40.6222 22.0561 40.9757 21.7018L43.1151 19.5626L40.4373 16.8844L38.297 19.0239C37.944 19.377 37.3905 19.4369 36.9696 19.1652C35.6695 18.3266 34.2433 17.7357 32.7315 17.4091C32.2422 17.3032 31.8929 16.8709 31.8929 16.3702V13.3461H28.1066V16.3702C28.1066 16.8709 27.7565 17.3032 27.2681 17.4091C25.7562 17.7356 24.3305 18.3266 23.03 19.1652C22.6103 19.4369 22.0564 19.3774 21.7034 19.023L19.5631 16.8839L16.8849 19.5621L19.0252 21.7012C19.3791 22.0556 19.4381 22.6082 19.1673 23.0292C18.3275 24.3301 17.7374 25.7554 17.4112 27.2672C17.3054 27.757 16.8726 28.1058 16.3719 28.1058H13.3478V31.8925H16.3719C16.8726 31.8925 17.3049 32.2422 17.4112 32.7307C17.7377 34.2425 18.3279 35.6682 19.1673 36.9687C19.4381 37.3897 19.3791 37.9423 19.0252 38.2962L16.8849 40.4357L19.5631 43.1139L21.7034 40.9744C22.0564 40.6205 22.6094 40.5606 23.03 40.8323C24.3322 41.6721 25.758 42.2622 27.2681 42.5884C27.7574 42.6942 28.1066 43.127 28.1066 43.6277V46.6527H31.8929V43.6277C31.8929 43.127 32.243 42.6947 32.7315 42.5888C34.2433 42.2623 35.6691 41.6709 36.9696 40.8318C37.3897 40.561 37.944 40.6197 38.297 40.974L40.4373 43.1131L43.1151 40.4353L40.9752 38.2966C40.6213 37.9436 40.5623 37.3901 40.8339 36.97C41.6725 35.6687 42.2635 34.2425 42.5887 32.7315C42.695 32.2422 43.1274 31.8934 43.6277 31.8934H46.6526L46.6522 28.1062L46.653 28.1063ZM47.7156 34.0191H44.4603C44.1343 35.1947 43.6677 36.3205 43.0671 37.3831L45.3685 39.6854C45.5689 39.8849 45.6807 40.1553 45.6807 40.4371C45.6807 40.7188 45.5689 40.9897 45.3685 41.1892L41.1874 45.3695C40.7719 45.785 40.0995 45.785 39.6848 45.3695L37.3825 43.0672C36.3212 43.6696 35.1941 44.1365 34.0185 44.4609V47.7169C34.0185 48.3037 33.5427 48.7795 32.9555 48.7795H27.0432C26.456 48.7795 25.9802 48.3037 25.9802 47.7169V44.4609C24.8054 44.1357 23.6788 43.6687 22.6162 43.0676L20.3139 45.3691C19.8984 45.7846 19.2264 45.7846 18.8105 45.3691L14.6293 41.1888C14.2147 40.7733 14.2147 40.1009 14.6293 39.6849L16.9307 37.3826C16.3301 36.3209 15.8635 35.1946 15.5375 34.0186H12.2826C11.6955 34.0186 11.2196 33.5428 11.2196 32.956V27.0429C11.2196 26.4557 11.6963 25.9799 12.2826 25.9799H15.5375C15.8636 24.8042 16.3301 23.6788 16.9307 22.6158L14.6293 20.3135C14.4289 20.114 14.3172 19.8445 14.3172 19.5623C14.3172 19.2801 14.429 19.0097 14.6293 18.8106L18.8105 14.629C19.2264 14.2135 19.8983 14.2135 20.3139 14.629L22.6162 16.9313C23.6779 16.3298 24.8046 15.8632 25.9802 15.5376V12.2828C25.9802 11.6956 26.456 11.2198 27.0432 11.2198H32.9555C33.5427 11.2198 34.0185 11.6964 34.0185 12.2828V15.5376C35.1933 15.8637 36.3208 16.3302 37.3825 16.9313L39.6848 14.629C39.8843 14.4295 40.1547 14.3177 40.4369 14.3177C40.7174 14.3177 40.9883 14.4295 41.1874 14.629L45.3685 18.8106C45.5689 19.0101 45.6807 19.2797 45.6807 19.5623C45.6807 19.8441 45.5689 20.1145 45.3685 20.3135L43.0671 22.6158C43.6678 23.6776 44.1343 24.8039 44.4603 25.9799H47.7156C48.3032 25.9799 48.7786 26.4557 48.7786 27.0429V32.956C48.7786 33.5428 48.3032 34.0191 47.7156 34.0191ZM30.2184 28.937C31.8863 28.937 33.2421 30.2939 33.2421 31.9611C33.2421 33.3362 32.3191 34.4996 31.0613 34.8657V35.2074C31.0613 35.7946 30.5859 36.2704 29.9983 36.2704C29.4115 36.2704 28.9357 35.7946 28.9357 35.2074V34.9104C28.2258 34.7489 27.5846 34.3317 27.148 33.7289C26.8046 33.2523 26.9109 32.5884 27.3867 32.245C27.8625 31.9008 28.5277 32.0075 28.8711 32.4833C29.0415 32.7191 29.3144 32.86 29.6004 32.86H30.218C30.7132 32.86 31.1152 32.4567 31.1152 31.9615C31.1152 31.4663 30.7124 31.0634 30.218 31.0634H29.7785C28.1106 31.0634 26.7548 29.7065 26.7548 28.0394C26.7548 26.6647 27.6769 25.5008 28.9349 25.1343V24.7926C28.9349 24.2054 29.4107 23.7296 29.9974 23.7296C30.585 23.7296 31.0604 24.2054 31.0604 24.7926V25.0896C31.7704 25.2515 32.412 25.6683 32.8473 26.271C33.1915 26.7464 33.0856 27.4116 32.609 27.755C32.1332 28.0992 31.4692 27.9933 31.1246 27.5167C30.9542 27.2809 30.6821 27.14 30.3953 27.14H29.7777C29.2829 27.14 28.8796 27.5433 28.8796 28.0385C28.8796 28.5337 29.2829 28.9365 29.7777 28.9365L30.2185 28.9361L30.2184 28.937ZM38.0897 30C38.0897 34.4612 34.4604 38.0906 29.9982 38.0906C25.5378 38.0906 21.9081 34.4617 21.9081 30C21.9085 25.5384 25.5378 21.9094 29.9991 21.9094C34.4604 21.9094 38.0897 25.5387 38.0897 30ZM40.2161 30C40.2161 35.633 35.6334 40.2161 29.9991 40.2161C24.3656 40.2161 19.783 35.633 19.783 30C19.783 24.3665 24.3657 19.783 29.9991 19.783C35.6325 19.783 40.2161 24.3665 40.2161 30ZM45.883 52.9063C41.2041 56.1569 35.7119 57.8741 29.9991 57.8741C23.1149 57.8741 16.5774 55.3752 11.4663 50.8169L14.417 51.054C15.0016 51.1004 15.5159 50.6646 15.5619 50.0791C15.6091 49.4937 15.1729 48.9816 14.587 48.9343L8.68184 48.4601C8.37095 48.4352 8.06513 48.5483 7.8462 48.7685C7.62474 48.9887 7.51296 49.2945 7.53784 49.605L8.01155 55.5113C8.05711 56.0669 8.52238 56.4891 9.07118 56.4891C9.09944 56.4891 9.12812 56.4879 9.15765 56.4853C9.7423 56.4381 10.1776 55.9252 10.1321 55.3405L9.88361 52.2515C15.4074 57.2539 22.5138 60 29.9984 60C36.1473 60 42.0595 58.1503 47.095 54.6525C47.5763 54.3175 47.6965 53.6553 47.3603 53.1727C47.0258 52.691 46.3639 52.5716 45.8818 52.9061L45.883 52.9063ZM2.12542 30C2.12542 23.1158 4.62479 16.5782 9.18218 11.4672L8.94637 14.4183C8.89913 15.0029 9.3353 15.5159 9.92079 15.5632C9.94905 15.5648 9.97773 15.5661 10.0073 15.5661C10.5552 15.5661 11.0201 15.1447 11.0656 14.5883L11.5398 8.68313C11.5646 8.37225 11.452 8.06643 11.2314 7.84623C11.0121 7.62603 10.7058 7.51383 10.3958 7.53829L4.48982 8.01242C3.9039 8.05967 3.46859 8.57261 3.51499 9.1573C3.56139 9.7428 4.07391 10.1781 4.65987 10.1321L7.74809 9.8841C2.74612 15.4083 0 22.5143 0 30.0011C0 36.1492 1.84928 42.0611 5.3471 47.0965C5.55338 47.3939 5.88451 47.553 6.22113 47.553C6.43035 47.553 6.64126 47.4905 6.82687 47.3631C7.30901 47.0274 7.42797 46.3655 7.09432 45.8834C3.84292 41.2058 2.1256 35.7136 2.1256 30.0006L2.12542 30ZM14.1174 7.09263C18.795 3.84329 24.2872 2.12607 30.0002 2.12607C36.8852 2.12607 43.423 4.62501 48.533 9.18196L45.5823 8.94532C44.9964 8.89934 44.4843 9.33467 44.4374 9.91973C44.3902 10.5052 44.8264 11.0173 45.4123 11.0649L51.3175 11.5386C51.3457 11.5412 51.3744 11.5416 51.4027 11.5416C51.684 11.5416 51.9536 11.4311 52.1539 11.2303C52.3741 11.0101 52.4863 10.7047 52.4619 10.3938L51.9882 4.48863C51.9409 3.90314 51.4288 3.46782 50.8433 3.5138C50.2574 3.56104 49.8212 4.07314 49.868 4.65868L50.1161 7.74766C44.591 2.74525 37.4859 0 29.9991 0C23.8502 0 17.9391 1.84885 12.9047 5.3471C12.4217 5.68203 12.3023 6.3443 12.6381 6.82642C12.9722 7.30856 13.6349 7.4271 14.117 7.09259L14.1174 7.09263ZM56.4862 50.8426C56.439 50.258 55.9273 49.8214 55.341 49.8678L52.2521 50.1162C57.2549 44.5903 59.9997 37.486 59.9997 29.9993C59.9997 23.8511 58.15 17.9382 54.6526 12.9027C54.3177 12.4206 53.655 12.3012 53.1729 12.6361C52.6916 12.9711 52.5718 13.6333 52.9063 14.1154C56.156 18.793 57.8737 24.2857 57.8737 29.9993C57.8737 36.8835 55.3743 43.421 50.8165 48.5321L51.054 45.5814C51.1 44.9959 50.6638 44.4839 50.0779 44.4366C49.492 44.3893 48.9807 44.8259 48.9339 45.411L48.4602 51.3162C48.4348 51.627 48.5479 51.9337 48.7681 52.1531C48.9685 52.3538 49.2393 52.4644 49.5198 52.4644C49.548 52.4644 49.5767 52.4631 49.605 52.4614L55.5102 51.9873C56.0965 51.94 56.5322 51.4279 56.4863 50.8424L56.4862 50.8426Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </div>
                            <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-12 col-9">
                              <p>Revenue</p>
                              <h3>
                                {currency?.symbol ? currency?.symbol : "$"}
                                {totalRevenue ? totalRevenue.toFixed(2) : 0}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3">
                        <div className="tile">
                          <div className="row">
                            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-3">
                              <div className="tileImg">
                                {/* <img src={clientsIcon} /> */}

                                <span>
                                  <svg
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M54.7992 48.1636C56.1921 47.1017 57.0967 45.4306 57.0967 43.5483C57.0967 40.6771 54.9996 38.2927 52.258 37.8291V36.7741C52.258 34.1059 50.0875 31.9354 47.4193 31.9354H30.9677V28.4087C31.4904 28.8066 32.1181 29.0322 32.786 29.0322C34.4156 29.0322 35.7385 27.7335 35.7956 26.1181C37.375 26.0619 38.6426 24.7943 38.6988 23.2149C40.2782 23.1587 41.5458 21.8911 41.602 20.3116C43.2173 20.2546 44.5161 18.9309 44.5161 17.3021C44.5161 16.4951 44.2015 15.7365 43.6317 15.1663L43.4304 14.9649C44.7598 13.3336 45.4838 11.3129 45.4838 9.17883C45.4838 4.1176 41.3662 0 36.3049 0C33.9366 0 31.7121 0.898185 29.9999 2.52C28.2878 0.898174 26.0632 0 23.6949 0C18.6336 0 14.516 4.1176 14.516 9.17883C14.516 11.5567 15.4207 13.7911 17.0564 15.5059C16.6702 16.0247 16.4516 16.6443 16.4516 17.3022C16.4516 18.9318 17.7502 20.2547 19.3656 20.3117C19.4218 21.8912 20.6894 23.1588 22.2688 23.2149C22.325 24.7944 23.5926 26.062 25.1721 26.1182C25.2291 27.7335 26.5528 29.0322 28.1816 29.0322C28.4758 29.0322 28.7583 28.9769 29.0322 28.8966V31.9355H12.5806C9.91243 31.9355 7.74193 34.106 7.74193 36.7742V37.8292C5.00029 38.2928 2.90322 40.6771 2.90322 43.5484C2.90322 45.4308 3.80789 47.1018 5.2007 48.1637C2.14241 49.5163 0 52.5756 0 56.129V60H17.4193V56.129C17.4193 52.5756 15.2769 49.5164 12.2186 48.1637C13.6115 47.1018 14.5161 45.4307 14.5161 43.5484C14.5161 40.6771 12.4191 38.2927 9.67741 37.8292V36.7742C9.67741 35.1735 10.9799 33.871 12.5806 33.871H29.0322V37.8292C26.2906 38.2919 24.1935 40.6762 24.1935 43.5484C24.1935 45.4308 25.0982 47.1018 26.491 48.1637C23.4327 49.5163 21.2903 52.5756 21.2903 56.129V60H38.7096V56.129C38.7096 52.5756 36.5672 49.5164 33.5089 48.1637C34.9018 47.1018 35.8064 45.4307 35.8064 43.5484C35.8064 40.6771 33.7094 38.2927 30.9677 37.8292V33.871H47.4193C49.02 33.871 50.3225 35.1735 50.3225 36.7742V37.8292C47.5809 38.2919 45.4838 40.6763 45.4838 43.5484C45.4838 45.4308 46.3885 47.1018 47.7813 48.1637C44.723 49.5163 42.5806 52.5756 42.5806 56.129V60H59.9999V56.129C59.9999 52.5756 57.8575 49.5163 54.7992 48.1636ZM36.3049 1.93545C40.2985 1.93545 43.5482 5.18518 43.5482 9.1788C43.5482 10.7941 43.0168 12.324 42.0483 13.582L37.5984 9.13212C37.887 8.91525 38.1665 8.68497 38.4266 8.42576L37.0584 7.05754C35.9922 8.12335 34.5765 8.70967 33.0687 8.70967H31.535L29.8829 10.3618C29.7001 10.5445 29.456 10.6452 29.1977 10.6452H25.5617C25.3414 10.6452 25.1612 10.4651 25.1612 10.2447C25.1612 10.1393 25.204 10.0356 25.2783 9.96131L31.1824 4.0572C32.5511 2.68942 34.3694 1.93545 36.3049 1.93545ZM23.6944 1.93545C25.5408 1.93545 27.2768 2.62842 28.6212 3.87956L23.9083 8.59251C23.468 9.03275 23.2252 9.62031 23.2252 10.2446C23.2252 11.5326 24.2733 12.5806 25.5612 12.5806H29.1971C29.9722 12.5806 30.7018 12.2786 31.2505 11.7299L32.3353 10.6451H33.0681C34.0349 10.6451 34.9716 10.4602 35.8446 10.1168L42.2628 16.5349C42.4667 16.7401 42.5799 17.0119 42.5799 17.3022C42.5799 17.9001 42.093 18.387 41.4951 18.387C41.2048 18.387 40.933 18.2738 40.7278 18.0695L38.4256 15.7673L37.0574 17.1355L39.3596 19.4377C39.5635 19.6434 39.6767 19.9151 39.6767 20.2054C39.6767 20.8033 39.1898 21.2902 38.5919 21.2902C38.3016 21.2902 38.0298 21.177 37.8246 20.9727L35.5224 18.6705L34.1542 20.0387L36.4564 22.3409C36.6603 22.5466 36.7735 22.8183 36.7735 23.1086C36.7735 23.7065 36.2866 24.1934 35.6887 24.1934C35.3984 24.1934 35.1266 24.0803 34.9214 23.8759L32.6192 21.5737L31.2509 22.9419L33.5532 25.2441C33.7571 25.4498 33.8703 25.7215 33.8703 26.0118C33.8703 26.6098 33.3834 27.0967 32.7855 27.0967C32.4951 27.0967 32.2234 26.9835 32.0182 26.7791L31.695 26.456C31.8505 26.0883 31.9348 25.6904 31.9348 25.2783C31.9348 23.6487 30.6361 22.3259 29.0207 22.2688C28.9646 20.6893 27.697 19.4218 26.1175 19.3656C26.0614 17.7861 24.7938 16.5185 23.2143 16.4623C23.1573 14.8471 21.8336 13.5483 20.2048 13.5483C19.5533 13.5483 18.9398 13.7613 18.4261 14.1397C17.1542 12.7905 16.4509 11.0408 16.4509 9.17882C16.4509 5.1852 19.7008 1.93545 23.6944 1.93545ZM18.3865 17.3021C18.3865 17.0117 18.4997 16.74 18.704 16.5348L19.4376 15.8012C19.6428 15.5969 19.9146 15.4837 20.2049 15.4837C20.8028 15.4837 21.2897 15.9706 21.2897 16.5685C21.2897 16.8588 21.1765 17.1306 20.9722 17.3358L20.2386 18.0694C20.0334 18.2737 19.7617 18.3869 19.4713 18.3869C18.8734 18.3869 18.3865 17.9 18.3865 17.3021ZM21.2897 20.2053C21.2897 19.915 21.4029 19.6432 21.6073 19.438L22.3408 18.7044C22.5461 18.5001 22.8178 18.3869 23.1081 18.3869C23.706 18.3869 24.1929 18.8738 24.1929 19.4717C24.1929 19.762 24.0798 20.0338 23.8754 20.239L23.1418 20.9726C22.9366 21.1769 22.6649 21.2901 22.3745 21.2901C21.7766 21.2901 21.2897 20.8032 21.2897 20.2053ZM24.1929 23.1085C24.1929 22.8182 24.3061 22.5465 24.5105 22.3412L25.2441 21.6077C25.4493 21.4033 25.721 21.2901 26.0114 21.2901C26.6093 21.2901 27.0962 21.777 27.0962 22.3749C27.0962 22.6653 26.983 22.937 26.7786 23.1422L26.0451 23.8758C25.8398 24.0802 25.5681 24.1933 25.2778 24.1933C24.6799 24.1933 24.1929 23.7064 24.1929 23.1085ZM28.181 27.0966C27.5831 27.0966 27.0962 26.6097 27.0962 26.0118C27.0962 25.7215 27.2094 25.4497 27.4138 25.2445L28.1473 24.5109C28.3526 24.3066 28.6243 24.1934 28.9146 24.1934C29.5125 24.1934 29.9994 24.6803 29.9994 25.2782C29.9994 25.5685 29.8863 25.8403 29.6819 26.0455L28.9483 26.7791C28.7431 26.9834 28.4714 27.0966 28.181 27.0966ZM15.4832 56.1288V58.0643H13.5477V54.1934H11.6122V58.0643H5.80576V54.1934H3.87028V58.0643H1.9348V56.1288C1.9348 52.3936 4.97372 49.3546 8.70898 49.3546C12.4442 49.3546 15.4832 52.3936 15.4832 56.1288ZM12.5799 43.5482C12.5799 45.6829 10.8437 47.4192 8.70898 47.4192C6.57431 47.4192 4.83802 45.6829 4.83802 43.5482C4.83802 41.4135 6.57431 39.6772 8.70898 39.6772C10.8437 39.6772 12.5799 41.4135 12.5799 43.5482ZM36.7735 56.1288V58.0643H34.838V54.1934H32.9025V58.0643H27.0961V54.1934H25.1606V58.0643H23.2251V56.1288C23.2251 52.3936 26.264 49.3546 29.9993 49.3546C33.7345 49.3546 36.7735 52.3936 36.7735 56.1288ZM33.8703 43.5482C33.8703 45.6829 32.134 47.4192 29.9993 47.4192C27.8646 47.4192 26.1283 45.6829 26.1283 43.5482C26.1283 41.4135 27.8646 39.6772 29.9993 39.6772C32.134 39.6772 33.8703 41.4135 33.8703 43.5482ZM47.4186 43.5482C47.4186 41.4135 49.1549 39.6772 51.2896 39.6772C53.4243 39.6772 55.1606 41.4135 55.1606 43.5482C55.1606 45.6829 53.4243 47.4192 51.2896 47.4192C49.1549 47.4192 47.4186 45.6829 47.4186 43.5482ZM58.0638 58.0643H56.1283V54.1934H54.1928V58.0643H48.3864V54.1934H46.4509V58.0643H44.5154V56.1288C44.5154 52.3936 47.5543 49.3546 51.2896 49.3546C55.0249 49.3546 58.0638 52.3936 58.0638 56.1288V58.0643Z" />
                                    <path d="M35.8062 35.8066H37.7416V37.7421H35.8062V35.8066Z" />
                                    <path d="M39.6772 35.8066H41.6127V37.7421H39.6772V35.8066Z" />
                                    <path d="M43.5483 35.8066H45.4838V37.7421H43.5483V35.8066Z" />
                                    <path d="M14.5156 35.8066H16.4511V37.7421H14.5156V35.8066Z" />
                                    <path d="M18.3867 35.8066H20.3222V37.7421H18.3867V35.8066Z" />
                                    <path d="M22.2578 35.8066H24.1933V37.7421H22.2578V35.8066Z" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                            <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-12 col-9">
                              <p>New Clients</p>
                              <h3>{newClients ? newClients : 0}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3">
                        <div className="tile">
                          <div className="row">
                            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-3">
                              <div className="tileImg">
                                {/* <img src={revenueIcon} /> */}

                                <span>
                                  <svg
                                    width="50"
                                    height="60"
                                    viewBox="0 0 50 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M24.834 33.0882V32.4157V31.8082L25.4282 31.682C26.2976 31.4973 26.8978 31.1462 27.299 30.672C27.7622 30.124 28.0394 29.3192 28.0394 28.1652C28.0394 27.437 27.9348 26.8809 27.7596 26.4693C27.5637 26.0087 27.3429 25.7001 27.1192 25.5024C26.8458 25.2608 26.281 24.8723 25.3751 24.3251L25.3749 24.325C25.3173 24.2902 25.2612 24.2558 25.2088 24.2236L25.1921 24.2134L24.834 33.0882ZM24.834 33.0882H23.8154V32.3932V31.7722L23.2052 31.6564C22.5601 31.5339 21.989 31.2513 21.4816 30.7961L21.4814 30.796C21.013 30.376 20.6715 29.5458 20.6635 28.0682H22.7278V28.1918C22.7278 28.6787 22.737 29.0844 22.7567 29.4039C22.7749 29.6999 22.8051 29.9913 22.8729 30.2052L22.8729 30.2052C22.9539 30.4609 23.1118 30.7016 23.3666 30.868C23.6115 31.0278 23.8818 31.0771 24.1218 31.0771C24.5479 31.0771 24.9783 30.922 25.2667 30.5256L25.2667 30.5256C25.5178 30.1804 25.5868 29.7558 25.5868 29.3654C25.5868 28.5592 25.5337 27.8837 25.3824 27.4181C25.2757 27.0887 25.063 26.8091 24.8239 26.5745C24.5807 26.3359 24.2733 26.1081 23.919 25.8878C23.7618 25.7896 23.6126 25.695 23.4693 25.6035C22.6292 25.0671 22.0746 24.6826 21.7789 24.44L21.7783 24.4396C21.4906 24.204 21.2128 23.8478 20.9623 23.3359C20.7337 22.869 20.6108 22.3255 20.6108 21.6894C20.6108 20.7712 20.8662 20.1451 21.2967 19.7127L24.834 33.0882ZM23.8162 17.6748H24.8339V18.1402V18.7526L25.4339 18.8751C26.1929 19.03 26.7032 19.3138 27.0362 19.6769C27.4109 20.0864 27.6457 20.6863 27.6589 21.5657H25.559C25.556 21.3029 25.5454 21.0695 25.5254 20.8692C25.5031 20.6458 25.464 20.4016 25.377 20.1964L25.377 20.1964C25.2734 19.952 25.0965 19.747 24.8535 19.6135C24.623 19.4868 24.3768 19.448 24.157 19.448C23.7113 19.448 23.2997 19.6398 23.0392 20.0402C22.8128 20.3872 22.7541 20.8125 22.7541 21.2038C22.7541 21.8187 22.8684 22.465 23.306 22.9046C23.4657 23.0674 23.7164 23.2548 24.0053 23.453C24.3108 23.6626 24.7076 23.9165 25.1917 24.2131L23.8162 17.6748ZM23.8162 17.6748V18.1227V18.7544L23.1936 18.8618C22.2927 19.0171 21.6869 19.3209 21.2968 19.7127L23.8162 17.6748Z"
                                      stroke="#007D87"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M12.0391 41.4471V49.9671H12.036V49.9781H3.58257H2.83257V50.7281V59.2499H0.75V47.8952H9.20612H9.95612V47.1452V38.6123L24.3852 38.6115L24.3886 38.6115C31.6507 38.578 37.5568 32.6436 37.5568 25.3813C37.5568 21.0209 35.4696 17.051 31.9959 14.594L35.2537 14.5943C38.0809 17.4594 39.6824 21.3313 39.6824 25.3818C39.6824 29.4847 38.086 33.3386 35.1847 36.24L35.1846 36.24C32.2838 39.1413 28.4299 40.7377 24.3265 40.7377C24.0978 40.7377 20.1027 40.7233 16.7562 40.7113C15.0947 40.7053 13.5931 40.6999 12.7917 40.6971L12.0391 40.6945V41.4471Z"
                                      stroke="#007D87"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M37.7081 0.750792L49.0635 0.750049V12.1047H46.981V6.11606V4.3054L45.7006 5.58573L39.1368 12.1496L24.1454 12.1518V12.1517L24.1349 12.1518C16.9421 12.2535 11.0946 18.1861 11.0946 25.3809C11.0946 29.7433 13.1838 33.7146 16.6604 36.1715H13.4008C10.5716 33.3057 8.96924 29.4325 8.96924 25.3807C8.96924 21.2777 10.5656 17.4239 13.4669 14.5225L13.467 14.5224C16.3677 11.6211 20.222 10.0248 24.3251 10.0248C24.625 10.0248 36.2039 10.0508 37.973 10.0552L38.2848 10.056L38.5052 9.83552L44.227 4.11374L45.5073 2.83341H43.6967H37.7081V0.750792Z"
                                      stroke="#007D87"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M39.6824 59.2502H32.9927V40.9537C34.4172 40.1587 35.7395 39.1619 36.923 37.9785C38.0018 36.8996 38.9254 35.7059 39.6824 34.4247V59.2502Z"
                                      stroke="#007D87"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M30.4559 59.25H23.7661V43.1948C24.0799 43.1957 24.2784 43.1962 24.3263 43.1962C26.449 43.1962 28.5168 42.8269 30.4559 42.1179V59.25Z"
                                      stroke="#007D87"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M14.5654 43.1619V59.2496H21.2649V43.186C20.8117 43.1843 20.3277 43.1826 19.8268 43.1809C18.8583 43.1774 17.827 43.1738 16.835 43.1701L14.5654 43.1619ZM14.5654 43.1619C15.2442 43.1645 16.0214 43.1673 16.8348 43.1701L14.5654 43.1619Z"
                                      stroke="#007D87"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M5.33594 52.4414H12.0354V59.2501H5.33594V52.4414Z"
                                      stroke="#007D87"
                                      strokeWidth="1.5"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </div>
                            <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-12 col-9">
                              <p>Average Order Value</p>
                              <h3>
                                {currency?.symbol ? currency?.symbol : "$"}
                                {averageRevenue ? averageRevenue : 0}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card mt-4 mb-4 rounded-1">
                      <div className="card-header">
                        <h3 className="mb-0">Monthly Revenue</h3>
                      </div>
                      {/* <div className="card-body"> */}
                      <ResponsiveContainer width="99%" height={400}>
                        <BarChart
                          width={1600}
                          height={300}
                          isAnimationActive={false}
                          data={revenueByDate}
                          margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                          barSize={20}
                        >
                          <XAxis
                            dataKey="name"
                            // scale="point"
                            padding={{ left: 10, right: 10 }}
                          />
                          <YAxis tickFormatter={formatter} />
                          <Tooltip content={<CustomTooltip />} />
                          <Legend />
                          {/* <CartesianGrid strokeDasharray="3 3" /> */}
                          <Bar
                            dataKey="revenue"
                            fill="#007D87"
                            background={{ fill: "#eee" }}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {currentList && currentList.length > 0 ? (
              <div className="listingSection horizontalPadding">
                <div className="sectionPagination justify-content-end">
                  <PaginationNewUI
                    itemsPerPage={itemsPerPage}
                    itemOffset={itemOffset}
                    setItemOffset={setItemOffset}
                    pageCount={pageCount}
                    totalRecordsCount={totalRecordsCount}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="common-table rounded-1">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Service Name</th>
                              <th>Units Sold</th>
                              <th>Revenue</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentList &&
                              currentList.length > 0 &&
                              currentList.map((item, idx) => {
                                return (
                                  <tr key={idx}>
                                    <td>{item.serviceName}</td>
                                    <td>{item.unitsSold}</td>
                                    <td>
                                      {currency?.symbol
                                        ? currency?.symbol
                                        : "$"}
                                      {item.revenueGenerated}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default Dashboard;
